import { useCallback, useEffect, useState } from "react";
import { fetchEvents, Event } from "../api/contentful";

export function useEvents() {
  const [data, setData] = useState<Event[] | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const refetch = useCallback(() => {
    setLoading(true);
    return fetchEvents({ fresh: true })
      .then((res) => setData(res))
      .catch((err) => setError(err.message || "Failed to load events"))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { data, loading, error, refetch };
}
